interface TorchButtonProps {
  on: boolean;
  onToggle: () => void;
}

export function TorchButton({ on, onToggle }: TorchButtonProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={on}
      aria-label={on ? 'Turn flashlight off' : 'Turn flashlight on'}
      title={on ? 'Flashlight on' : 'Flashlight off'}
      data-testid="torch-toggle"
      className={[
        'absolute right-3 top-3 flex h-11 w-11 items-center justify-center rounded-full',
        'ring-1 backdrop-blur-sm transition-colors',
        on
          ? 'bg-amber-400 text-gray-900 ring-amber-200'
          : 'bg-gray-900/60 text-gray-100 ring-gray-500 hover:bg-gray-800/80',
      ].join(' ')}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
        aria-hidden="true"
      >
        <path d="M18 6H6l3 4v10h6V10z" />
        <path d="M9 2h6" />
      </svg>
    </button>
  );
}
